import React, { useEffect, useState } from "react";
import { Link as GatsbyLink } from "gatsby";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import Button from "../vendor/mui-pro/src/components/CustomButtons/Button";
import Header from "../vendor/mui-pro/src/components/Header/Header";
import headerLinksStyle from "../vendor/mui-pro/src/assets/jss/material-kit-pro-react/components/headerLinksStyle";
import { createStyles } from "@material-ui/core";
import makeStyles from "@material-ui/core/styles/makeStyles";
import clsx from 'clsx';
import NavigationNode from "../components/navigation-node";
import Typography from "@material-ui/core/Typography";
import Colors from "../constants/Colors";
import useWindowScroll from "../hooks/useWindowScroll";

const baseStyles = makeStyles(headerLinksStyle);
const uniqueStyles = makeStyles({
  root: { borderRadius: 0 },
  button: { color: Colors.white, textDecoration: "none" },
  searchIcon: { fontSize: 24, transform: "translateY(-3px)" },
  displayNone: { display: "none" },
  linksContainer: { /* paddingRight: 0 */ },
});

const listStyles = makeStyles((theme) => createStyles({
  root: {
    [theme.breakpoints.up("md")]: {
      display: "flex",
      alignItems: "center",
      flexDirection: props => props.drawerOpen ? "column" : "row",
    }
  },
  logoContainer: { maxHeight: 48 },
  logoNoThrash: { maxHeight: 65 },
}));

function NavHeader({ widgetLinks = [], color, listItemStyling, logo, scrollLogo, secondary, heightHack, smallBreakpoint }) {
  const classes = baseStyles();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isRendered, setRender] = useState(false);

  const listClasses = listStyles({ drawerOpen });
  const scroll = useWindowScroll();
  const preScrolled = scroll >= 300;
  const scrolled = scroll >= 350;
  const listItemClasses = uniqueStyles();

  const handleDrawerToggle = () => setDrawerOpen(!drawerOpen);

  useEffect(() => { if (!isRendered) setRender(true); }, [isRendered]);

  // Sort by position so the menu order matches the CMS
  const sortedLinks = widgetLinks.slice().sort((a, b) => (a.position ?? 0) - (b.position ?? 0));

  return (
    <Header
      key={scrolled}
      logo={logo}
      disableGutters
      displayDrawer={smallBreakpoint}
      offset={!scrolled}
      secondary={scrolled || secondary}
      mobileOpen={drawerOpen}
      searchButtonOnClick={handleDrawerToggle}
      containerStyle={listItemClasses.logoContainer}
      color={preScrolled ? Colors.white : color}
      sticky={scrolled}
      heightHack={heightHack}
      classes={{
        customDrawerStyles: classes.customDrawerStyles,
        displayNone: classes.displayNone,
        container: listItemClasses.linksContainer,
      }}
      brand={
        <GatsbyLink to="/" activeClassName="header-ripple">
          {!preScrolled ? (
            <img
              className={clsx(drawerOpen && listClasses.logoNoThrash)}
              src={logo?.url}
              alt="logo"
            />
          ) : (
            <img
              className={clsx(drawerOpen && listClasses.logoNoThrash)}
              src={scrollLogo?.url}
              alt="logo-scrolled"
            />
          )}
        </GatsbyLink>
      }
      links={
        <List component="div" disablePadding className={listClasses.root}>
          {sortedLinks.map((L, idx) => (
            <ListItem key={idx} className={clsx(classes.listItem, listItemClasses.listItem)} button>
              {L.link ? (
                <NavigationNode classes={{ navStyle: listItemClasses.button }} datoItem={L.link}>
                  <Button
                    color="transparent"
                    className={clsx(classes.navButton, listItemClasses.button)}
                    style={scrolled ? { color: Colors.kashmirBlue } : listItemStyling}
                  >
                    <Typography variant="button">{L.label}</Typography>
                  </Button>
                </NavigationNode>
              ) : (
                <a
                  href={L.externalLink}
                  target="_blank"
                  rel="noopener"
                  className={clsx(classes.navButton, listItemClasses.button)}
                >
                  <Button
                    color="transparent"
                    className={clsx(classes.navButton, listItemClasses.button)}
                    style={scrolled ? { color: Colors.kashmirBlue } : listItemStyling}
                  >
                    <Typography variant="button">{L.label}</Typography>
                  </Button>
                </a>
              )}
            </ListItem>
          ))}
        </List>
      }
    />
  );
}

export default NavHeader;
